import styled from 'styled-components';

export const StyledButton = styled('button')<any>`
  background: ${(p) => p.color || '#0f0f0f'};
  color: ${(p) => (p.color ? '#0f0f0f' : '#fff')};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid #edf3f5;
  border-radius: 4px;
  padding: 13px 0;
  cursor: pointer;
  max-width: 180px;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: black;
    border: 1px solid black;
    background-color: #fff;
  }
`;
